import _ from 'underscore';
import Promise from 'bluebird';
import { projectionGridScopeNavigator } from '@bingads-webui-campaign/projection-grid-scope-navigator';
import { placeholderPlugin } from '@bingads-webui/projection-grid-placeholder';

import placeholderTemplate from './empty-placeholder-template.pug';

export const getAdditionalPluginsFactory = ({
  toolbarPlugin,
  scope,
  i18n,
}) => view => [
  toolbarPlugin,
  {
    plugin: projectionGridScopeNavigator,
    config: scope,
  }, {
    plugin: placeholderPlugin,
    config: {
      container: '.brand-page .grid-noresult',
      template: placeholderTemplate,
      templateOptions: {
        i18n,
        _,
      },
      asyncEmptyText: view.tooMuchDataErrorText,
      asyncCallback: () => Promise.resolve(view.showTooMuchDataError),
    },
  },
];
